export default class Captcha {
  constructor(api) {
    this.api = api
  }

  verifyCaptcha = async (token, action) => {
    const res = await this.api.post('/VerifyCaptcha', {
      data: {
        action,
        token
      }
    })
    return res
  }
}
